
export class FinalReportMistakes {
    id?: number;
    criterionId?: number;
    criterionKey?: string;
    criterionType?: string;
    visitKey?: string;

    mistake?: string;
    mistakeLevel?: string;
    responseDecision?: string;
    notes?: string;
    suggestedSolution?: string;
}
